import "./styles.sass";

import React, { FC, useContext, useEffect, useState, useRef } from "react";
import { observer } from "mobx-react-lite";
import useFilters from "../../customHooks/useFilters";
import Header from "./Header";
import Article from "./Article";
import Filter from "../../components/filters/Filter";
import { Context } from "../..";
import Emptiness from "../../components/UI/emptiness/Emptiness";
import Spinner from "../../components/UI/spinner/Spinner";
import Pagination from "../../components/pagination/Pagination";
import Timofey from "../../assets/images/Timofey_avatar.png";
import { IArticle, IArticleRes } from "../../models/IArticle";
import { scrollToTop } from "../../utils";

export interface IPagination {
  allCount: number;
  countPages: number;
}

const Articles: FC = () => {
  const { articles, store, roles } = useContext(Context);
  const [pagination, setPagination] = useState<IPagination>({
    allCount: 0,
    countPages: 0,
  });
  const [page, setPage] = useState(1);
  const statusFilter = useFilters();
  const [userId, setUserId] = useState<any>()
  const [fetchUser, setFetchUser] = useState<any>()
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  const [allArticles, setAllArticles] = useState<IArticle[]>([]);

  const articleContainer = useRef<HTMLDivElement>(null);

  useEffect(() => {
    articles.setArticlesFilters(
      statusFilter.checkedValues,
    );
    articles.loadList(page).then((res: IArticleRes) => {
      scrollToTop(articleContainer);
      setAllArticles(res.result);
      setPagination(res.pagination);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusFilter.checkedValues, articles, page]);

  useEffect(() => {
    setAllArticles(articles.articlesList);
  }, [articles.articlesList]);
  
  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "marketing")?.children?.find((child: any) => child.path === "articles")
    setAdminPermissionData(userData)
  };
  
  const searchItems = (searchValue: string) => {
    if (searchValue !== "") {
      const filteredData = articles.articlesList.filter((item: any) => {
        const { content: _, ...rest } = item;
        return Object.values(rest)
          .join("")
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setAllArticles(filteredData);
    } else {
      setAllArticles(articles.articlesList);
    }
  };


  return (
    <div className="articles">
      <Header page={page} searchItems={searchItems} actionData={adminPermissionData}/>
      <div ref={articleContainer} className="body">
        {allArticles.length > 0 && !articles.loadingArticlesBool ? (
          allArticles.map((article, index) => (
            <Article page={page} item={article} key={article._id} Article={articles} actionData={adminPermissionData}/>
          ))
        ) : allArticles.length === 0 && !articles.loadingArticlesBool ? (
          <Emptiness icon={Timofey} content="It's time to create an article!" />
        ) : (
          <Spinner />
        )}
      </div>
      <div className="filters">
        <Filter
          title="Status"
          list={[
            { label: "Active", default: true, value: "show" },
            { label: "Archive", default: false, value: "hidden" },
            { label: "Delete", default: false, value: "deleted" },
          ]}
          onSelect={statusFilter.handleSelect}
        />
      </div>
      <Pagination
        totalItems={pagination.allCount}
        itemsPerPage={12}
        currentPage={page}
        onPageChange={setPage}
      />
    </div>
  );
};

export default observer(Articles);
